<div class="data-content">
    <nz-card *ngIf="showCard" [nzTitle]="cardHeader" class="filter-card">
        <ng-template #cardHeader>
            <div class="card-header-title">
                <span class="header-image"><nz-icon nzType="filter"></nz-icon></span>
                <span>{{title}}</span>
            </div>
        </ng-template>

        <ng-container [ngTemplateOutlet]="fields"></ng-container>

        <div class="actions-buttons">
            <button nz-button nzType="primary" (click)="ok()">{{'confirm'|translateTA}}</button>
            <button nz-button nzDanger (click)="cancelar()">{{'cancel'|translateTA}}</button>
        </div>
    </nz-card>
    <ng-container  [ngTemplateOutlet]="fields" *ngIf="!showCard"></ng-container>
</div>

<ng-template #fields>
    <div class="content form-field-density-4" >
        <form [formGroup]="formGroup">
            <div *ngFor="let param of parameters">
            <ng-container  #viewContainer2 dynamicField  [config]="param" [group]="formGroup"  [arrayColumnsDef]="parameters" [isDynamicform]="false" class="full" [showBuscaDados]="false">
            </ng-container>
            </div>
        </form>
    </div>
</ng-template>
